module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageFaq":{"breadcrumbs":{"faq":"Časté dotazy","index":"Poradna"},"heading":"Nejčastější dotazy","seo":{"description":"FAQ - často kladené otázky a naše odpovědi na {website}","keywords":"často kladené dotazy, faq, otázky a odpovědi, {website}","title":"FAQ - často kladené otázky a naše odpovědi"}}}}')
  delete Component.options._Ctor
}
